// extracted by mini-css-extract-plugin
export default {"icon":"Loader_icon__haivp","spin":"Loader_spin__Qmx6+"};